import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import OptInStrings from './OptInStrings';
export var VerifyEmailAddressModal = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(Modal, { title: OptInStrings.verifyEmailAddressModal.title(), primaryAction: {
            text: OptInStrings.verifyEmailAddressModal.gotIt(),
            onClick: onClose,
        }, size: Modal.Sizes.Small, onClose: onClose }, OptInStrings.verifyEmailAddressModal.subtext()));
};
export default VerifyEmailAddressModal;
